import React from 'react';

const Step2Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-2">
        Sposta la freccia della nostra bussola sul punto cardinale verso il quale è rivolta la facciata di riferimento di casa tua.
        </div>
    );
}

export default Step2Infos;